/* eslint-disable @typescript-eslint/no-explicit-any */
import { createReducer } from 'reduxsauce'

import { ChatReportsTypes } from 'store/actions'
import { CHAT_REPORTS_INITIAL_STATE } from 'store/states'

/* ------------- Reducers ------------- */

export const resetChatReportsData = (state: any) => {
  return {
    ...state,
    hasDataToLoad: true,
    chats: [],
  }
}

export const getChatReportsData = (state: any, { payload }: any) => {
  const { loading } = payload
  return {
    ...state,
    loading,
    isRequesting: true,
  }
}

export const setChatReportsData = (state: any, { payload }: any) => {
  const { chats, limit, hasDataToLoad } = payload

  let newChats: any = []
  if (!chats) {
    newChats = [...state.chats]
  } else {
    newChats = [...state.chats]
    chats.map((data: any) => {
      const exists = newChats.find((d: any) => d.documentId === data.documentId)
      if (!exists) {
        newChats.push(data)
      }
    })
  }

  newChats.sort(function (a: any, b: any) {
    const keyA = new Date(a.created_at.seconds * 1000),
      keyB = new Date(b.created_at.seconds * 1000);

    if (keyA < keyB) return 1;
    if (keyA > keyB) return -1;
    return 0;
  });

  return {
    ...state,
    limit,
    hasDataToLoad,
    chats: newChats,
    loading: false,
    isRequesting: false,
    hasInitialized: true,
  }
}

export const updateChatReportsData = (state: any, { payload }: any) => {
  // eslint-disable-next-line camelcase
  const { hidden, documentId } = payload

  const updatedData = state.chats.map((data: any) => {
    if (data.documentId === documentId) {
      return {
        ...data,
        hidden
      }
    }

    return data
  })

  return {
    ...state,
    chats: updatedData,
    loading: false,
    isRequesting: false,
    hasInitialized: true,
  }
}

/* ------------- Hookup Reducers To Types ------------- */

export const chatReportsReducer = createReducer(CHAT_REPORTS_INITIAL_STATE, {
  // Mint Collection
  [ChatReportsTypes.RESET_CHAT_REPORTS_DATA]: resetChatReportsData,
  [ChatReportsTypes.GET_CHAT_REPORTS_DATA]: getChatReportsData,
  [ChatReportsTypes.SET_CHAT_REPORTS_DATA]: setChatReportsData,
  [ChatReportsTypes.UPDATE_CHAT_REPORTS_DATA]: updateChatReportsData,
})
